import { render, staticRenderFns } from "./TarefasForm.vue?vue&type=template&id=1bf192da&"
import script from "./TarefasForm.vue?vue&type=script&lang=js&"
export * from "./TarefasForm.vue?vue&type=script&lang=js&"
import style0 from "./TarefasForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports